module.exports = __webpack_public_path__ + "static/media/icon-tt-red.0192da32.svg";